import { Box, CircularProgress, Icon, useTheme } from "@mui/material";
// import clientIconDark from "../../../assets/icons/loginEmpresaLogoDark.png";
// import clientIcon from "../../../assets/icons/loginEmpresaLogoWhite.png";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useOutletContext } from "react-router-dom";
import api from "../../../services/api";
import UnauthorizedPage from "../../../components/unauthorizedPage";
const styles = {
  box: {
    m: 1,
    width: "100%",
    height: "70vh",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  icon: {
    width: "fit-content",
    height: "fit-content",
    margin: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  img: {
    width: 80,
    height: "auto",
  },
  circularProgress: {
    color: "primary",
    position: "absolute",
    zIndex: 1,
  },
};

// Verifica se o usuário é um administrador
function checkAdm() {
  let result = localStorage.getItem("user");
  result = JSON.parse(result);
  // Verifica se a propriedade rlPermissoesUsuario existe e é um array
  if (Array.isArray(result?.usuario?.rlPermissoesUsuario)) {
    // Itera sobre o array para verificar se algum objeto contém a propriedade codigoPermissao com valor "ADM"
    for (let permissao of result?.usuario?.rlPermissoesUsuario) {
      if (permissao?.permissao?.codigoPermissao?.toUpperCase() === "ADM") {
        return true;
      }
    }
    return false;
  }
}

export default function ProtectedRoute({ children }) {
  const [admChecked, setAdmChecked] = useState(null);
  const theme = useTheme();
  const { controllerDashboard, setControllerDashboard, api } =
    useOutletContext();
  useEffect(() => {
    //setAdmChecked(checkAdm());

    const admValidate = async () => {
      try {
        await api.get("/interno/checkAdmPermission");
        setAdmChecked(true);
      } catch (error) {
        setAdmChecked(false);
      }
    };
    admValidate();
  }, []);

  if (admChecked === null) {
    return (
      <Box sx={styles.box}>
        {/* <Icon style={styles.icon}>
					<img
						src={theme?.palette?.mode === "dark" ? clientIconDark : clientIcon}
						style={styles.img}
					/>
				</Icon> */}
        <CircularProgress
          size={100}
          sx={styles.circularProgress}
          thickness={2.5}
        />
      </Box>
    );
  }

  return admChecked ? (
    children ? (
      children
    ) : (
      <Outlet
        context={{
          controllerDashboard,
          setControllerDashboard,
          api,
        }}
      />
    )
  ) : (
    <UnauthorizedPage />
  );
}
